import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { ChrComponentsModule } from '@ciphr-design-system/angular';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { TableColumnHeaderComponent } from '@ciphr/shared/collections';

import { FileExportStore, FileManagerListItem } from '../../state/file-export.store';

@Component({
  standalone: true,
  imports: [ChrComponentsModule, TranslocoDirective, TableColumnHeaderComponent],
  templateUrl: './file-export-manager.component.html',
  styleUrls: ['./file-export-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExportManagerComponent {
  private fileExportStore = inject(FileExportStore);
  private dialogRef = inject(DialogRef);

  files: Signal<FileManagerListItem[]> = this.fileExportStore.files;
  currentDownloadingFiles: Signal<number> = this.fileExportStore.currentDownloadingFilesLength;
  hasErrorDuringDownloadingOccurred: Signal<boolean> = this.fileExportStore.hasErrorDuringDownloadingOccurred;

  cancelFileDownloading({ id }: FileManagerListItem): void {
    this.fileExportStore.removeFile(id);

    this.currentDownloadingFiles() === 0 && this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
